import React from "react";
import "../../../../../../Assets/Styles/HomeHeadSkillModal.scss";
import Select from "../../../ShareElements/Select/Select";

const SkillModal = (props) => {
  const shortenText = (Text, Length) => {
    if (Text.length < Length) {
      return Text;
    } else {
      let Short = Text.slice(0, 12) + " ....";
      return (
        <>
          <p className="popup-text">{Text}</p>
          {Short}
        </>
      );
    }
  };
  return (
    <div className="overlay">
      <div
        className="outline"
        onClick={() => {
          props.Close();
        }}
      ></div>
      {props.IsViewAll ? (
        <div className="skill-modal-body">
          <section className="modal-head">
            <h1>{props.translateText("all_recommended_skills")}</h1>
            <i
              className="feather-x"
              onClick={() => {
                props.Close();
              }}
            ></i>
          </section>
          <main className="main-content-holder main-content-flex">
            {props.SkillRecommendations.map((Recom) => (
              <div className="skill-item">
                {shortenText(Recom.skill.title, 20)}
                <img
                  alt=""
                  src={props.PlusIcon}
                  onClick={() => props.ReplaceSkill(Recom)}
                />
              </div>
            ))}
          </main>
        </div>
      ) : (
        <div className="skill-modal-body">
          <section className="modal-head">
            <h1>{props.translateText("replace_an_existing_skill")}</h1>
            <i
              className="feather-x"
              onClick={() => {
                props.Close();
              }}
            ></i>
          </section>
          <main className="main-content-holder">
            <p className="row-label">{props.translateText("select_a_skill")}</p>
            <Select
              Initial={
                props.UserSkills.length > 0 ? props.UserSkills[0].name : ""
              }
              Options={props.UserSkills}
              IsWithId
              Id={"skill"}
              PreSelected={true}
              PreSelectedId={
                props.UserSkills.length > 0 ? props.UserSkills[0].id : ""
              }
              ChangeHandler={() => null}
              ValidationError=""
            />
            <aside className="modal-footer">
              <span
                className="action-btn"
                onClick={() => {
                  props.Close();
                }}
              >
                {props.translateText("cancel")}
              </span>
              <span
                className="action-btn primary-action"
                onClick={() => props.Save()}
              >
                {props.translateText("save")}
              </span>
            </aside>
          </main>
        </div>
      )}
    </div>
  );
};

export default SkillModal;
